import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"



export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getApiEndpoint(): string {
  const endpoint = process.env.NODE_ENV === 'development'
  ? "http://localhost:3000/"
  : process.env.GRAPHQL_ENDPOINT?.replace('/api', '') || "http://localhost:3000/"

  return endpoint
}

export function getBaseUrl(): string {
  if (
    process.env.NODE_ENV === "development" &&
    process.env.NEXT_PUBLIC_SITE_URL &&
    process.env.NEXT_PUBLIC_SITE_URL !== ""
  ) {
    return process.env.NEXT_PUBLIC_SITE_URL;
  }
  return "http://localhost:3000/";
}

export function daysFromNow(days: number) {
  return new Date(Date.now() + days * 24 * 60 * 60 * 1000);
}

export function isExpired(date: Date) {
  return new Date(date) < new Date();
}
